import React from 'react'

import './slug.css'
import { styles } from './style'

const FooterSlug = () => {
  const deleteAccountStyles = styles()

  return (
    <>
      <div
        style={{
          background: 'white'
        }}
      >
        <div style={{ maxWidth: ' 1200px', margin: '0px auto' }}>
          <img src='/logo.webp' style={{ maxHeight: 60 }} />
        </div>
      </div>
      <div
        style={{
          paddingTop: '24px',
          paddingBottom: '38px',
          maxWidth: ' 1200px',
          margin: '0px auto'
        }}
      >
        <div className='main-container'>
          <h1 className='slug-title'>Account Deletion Policy</h1>
          <div>
            <p>
              Account deletion is <strong>not available directly through the app</strong>. To
              request account deletion, please send an email to{' '}
              <a href='mailto:halo@motapos.id'>halo@motapos.id</a> with your registered account
              information.
            </p>
            <p>
              If you cannot remember your password or username, you may reset your password by
              visiting the login page, selecting <strong>Forgot Password</strong>, and entering the
              email address or phone number previously registered.
            </p>
            <h6>
              <strong>Important Notes</strong>
            </h6>
            <ul className={deleteAccountStyles.list}>
              <li>
                Account deletion is <strong>permanent and irreversible</strong>. Once deleted, you
                will no longer be able to log in or access your account history.
              </li>
              <li>
                After deletion, you may sign up again using the same username or assign it to
                another account, provided the username has not been taken by someone else.
              </li>
              <li>
                <strong>Exceliconstore</strong> reserves the right to deny any future account
                creation requests from you after your account has been deleted.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}

export default FooterSlug
